import RiskReviews from 'pages/Finance/Components/Financing/common/Risk';
import React from 'react';

const Evaluations = (props: any) => {
  const { selectedRequest } = props;
  return (
    <RiskReviews
      item={selectedRequest}
      requestTypes={['factoring-request', 'factoring-request-payers']}
    />
  );
};

export default Evaluations;
